<div
    class="section-padding-vertical-md lg:section-padding-vertical-lg w-full grid grid-cols-1 lg:grid-cols-2 gap">
    <div class="flex flex-col gap-12">
        <p class="text-xl">
            Wir sind Alessandro und Felix, die Gründer von Marketing mit Geschmack. Dank unserer
            langjährigen Erfahrung und agilen Sichtweise wissen wir Strategie, Design & Technologie
            zu kombinieren, um deinen Online Erfolg zu maximieren. Unsere Websites sind mehr als
            eine Visitenkarte im Internet. Sie sind darauf ausgerichtet, dein Angebot an deinen
            Kunden zu bringen - noch bevor du überhaupt mit ihm gesprochen hast.
        </p>

        <div class="grid grid-cols-2 gap-6 items-end">
            <img alt="Alessandro Crispino - Geschäftsführer der WeCodeIt OG" loading="lazy"
                src="images/team/Alessandro%20Crispino.jpg"
                class="aspect-[2/2.5] object-cover rounded-medium" />
            <img alt="Felix Jiricka - Geschäftsführer der WeCodeIt OG" loading="lazy"
                src="images/team/Felix%20Jiricka.jpg"
                class="aspect-square object-cover rounded-medium" />
        </div>
    </div>

    <div class="flex flex-col gap-6">
        <div class="card colored mb-auto">
            <p class="text-lg text-white">
                Als Premium Agentur legen wir großen Wert darauf, jedes Projekt einzigartig auf deine
                Ziele auszurichten, um dir endlich den Erfolg zu ermöglichen, den du verdienst.<br />
                Für dich erstellen wir eine maßgeschneiderte Website mit messbarem Erfolg, die deine
                zukünftigen Kunden genau an der richtigen Stelle abholt. Wir kümmern uns hierbei um
                jeden Schritt deines Online Auftritts, sodass du dich auf dein Kerngeschäft
                konzentrieren kannst, während wir deine Vision realisieren.<br />
                So entstehen nicht einfach nur Websites sondern digitale Verkäufer, die nachhaltig
                erfolgreich sind.
            </p>
        </div>

        <div class="card bg-dark !spacing-md">
            <div class="flex flex-col gap-4 h-full items-center">
                <p class="text-white text-center">
                    Deine potenziellen Kunden bewerten dein Unternehmen und Angebot, noch bevor du mit ihnen sprechen kannst. Also überzeuge mit deinem Online Auftritt.
                </p>

                <wci-button
                    routerLink="/kontakt"
                    label="Jetzt Kunden gewinnen"
                    buttonClass="!rounded-medium"
                    class="mt-auto">
                    Jetzt Kunden gewinnen
                </wci-button>
            </div>
        </div>
    </div>
</div>
